import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";

export const Landing = () => {
  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            marginBottom: "1.25rem",
            fontSize: "1.5rem",
            fontWeight: "bold",
          }}
        >
          How can I help you today?
        </Typography>
      </Box>
    </Box>
  );
};
